import React from 'react'
import GainIcon from "../gainicon"

export default function EditButton(props) {
    return (
        <div className="cursor-pointer" onClick={props.onClick}>
            <GainIcon name="edit" />
        </div>
    )
}
